import { useAtomValue } from 'jotai';
import { useEffect, useMemo } from 'react';
import { UseControllerProps, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Option } from '@/lib/v2/components';

import { atomCreateOrEditIntegrationForm } from '@/src/modules/IntegrationsModule/atoms/integrations';

import { Field } from '@/modules/ContactsModule/types/Segments';

export interface CreateOrEditIntegrationForm {
  stepOne?: Option;
  stepTwo: (Field & { isChecked?: boolean; isDisabled?: boolean })[];
  stepThree?: Option;
  stepThreeGroups: Option[];
  stepFour: Option;
  stepFourSwitch: boolean;
}

export const useCreateOrEditIntegrationForm = () => {
  const { t } = useTranslation();
  const atomStateForm = useAtomValue(atomCreateOrEditIntegrationForm);

  const {
    control,
    formState: { isValid },
    handleSubmit,
    setValue,
  } = useForm<CreateOrEditIntegrationForm>({
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const rules: {
    [K in keyof CreateOrEditIntegrationForm]: UseControllerProps['rules'];
  } = useMemo(
    () => ({
      stepOne: {
        required: t('FORMS_RULES_MESSAGES.required'),
      },
      stepTwo: {},
      stepThree: {
        required: t('FORMS_RULES_MESSAGES.required'),
      },
      stepThreeGroups: {
        required: t('FORMS_RULES_MESSAGES.required'),
      },
      stepFour: {
        required: t('FORMS_RULES_MESSAGES.required'),
      },
      stepFourSwitch: {},
    }),
    [t]
  );

  useEffect(() => {
    Object.entries(atomStateForm).forEach(([key, value]) => {
      setValue(key as keyof CreateOrEditIntegrationForm, value);
    });
  }, [atomStateForm, setValue]);

  return {
    control,
    isValid,
    rules,
    handleSubmit,
  };
};
